
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
// import { addKpiCustomization } from "@/util/kpis";

export default {
  props: {
    kpisListBase: { type: Array, default: () => [] },
    allTrends: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    // renderAi: { type: Boolean, default: false },
    modifiedDate: { type: String, default: '' },
    // eslint-disable-next-line vue/require-default-prop
    lastTimeStamp: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      renderAi: false,
      trendOrder: 4,
      currentTrend: '',
      metricKeyShort: '',
      cardHover: '',
      kpisList: []
    };
  }, // data
  computed: {
    ...mapState('overview', { kpis: 'kpis' }),
    ...mapState('trend', ['targetSelectedPeriod', 'targetComparedPeriod']),
    ...mapState('user', ['kpiPreferences']),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState',
      'getEndingCompared'
    ])
  }, // computed
  watch: {
    kpisListBase(newValue) {
      this.kpisList = JSON.parse(JSON.stringify(newValue));
    },
    // 🔄 NEW WATCHER
    lastTimeStamp(newVal) {
      this.refreshOverviewData();
    },
    '$q.screen.width'() {
      if (!this.currentTrend) return;

      const index = this.kpisList.findIndex(
        k => k.metricKey === this.currentTrend
      );
      if (index === -1) return;

      const d = this.getCardsPerRow();
      const chatOpen = document.body.classList.contains('chat-open');

      if (chatOpen) {
        this.trendOrder = Math.ceil(index / 2) * 2;
      } else {
        this.trendOrder = Math.ceil((index + 1) / d) * d;
      }
    }
  },
  created() {
    this.kpiUpdated = JSON.parse(JSON.stringify(this.kpisList));
    // this.getOverviewData();
  },
  async mounted() {
    
    const checkRenderAi = setInterval(() => {
      if (window['renderAi']) {
        this.renderAi = true;
        clearInterval(checkRenderAi);
      }
    }, 300);
  },
  methods: {
    refreshOverviewData() {
      this.kpisList = JSON.parse(JSON.stringify(this.kpisListBase));
    },
    getTooltip(kpiName: any): String {
      // if (this.$te(`tooltip_${kpiName}`, 'locale')) {
      // if (!['facadestops'].includes(kpiName)) {
      return this.$t(`HomeTooltips.tooltip_${kpiName}`);
      // } else {
      // return '';
      // }
      // }

      // return '';
    },
    getVideo(kpiName: any): String {
      // if (this.$te(`video_${kpiName}`, true)) {
      if (['sales', 'conversion', 'traffic', 'avgpurchase'].includes(kpiName)) {
        return this.$t(`HomeTooltips.video_${kpiName}`);
      } else {
        return '';
      }

      // }

      // return '';
    },
    hoverCard(cardName) {
      this.cardHover = cardName;
    },
    leaveCard() {
      this.cardHover = '';
    },
    getCardsPerRow() {
      if (this.$q.screen.xs) return 1;
      if (this.$q.screen.sm) return 2;
      if (this.$q.screen.md) return 4; // or 4, depending on your design
      return 4; // lg & xl
    },
    cardClick(cardName, order, metricKeyShort, event) {
      const wrapper = document.querySelectorAll('.control-wrapper');
      if (wrapper[order - 1]?.contains(event.target)) return;

      // Track the click via Mixpanel
      Vue.prototype?.$mixpanel?.track(metricKeyShort, {
        referrer: document.referrer
      });

      // If the card is already active, close the trend box
      if (this.currentTrend === cardName) {
        this.currentTrend = '';
        this.metricKeyShort = '';
      } else {
        // Get number of cards per row dynamically
        const d = this.getCardsPerRow();

        // Determine if chat is open
        const chatOpen = document.body.classList.contains('chat-open');
        if (chatOpen) {
          this.trendOrder = Math.ceil(order / 2) * 2;
        } else {
          this.trendOrder = Math.ceil(order / d) * d;
        }

        // Set the currently active trend
        this.currentTrend = cardName;
        this.metricKeyShort = metricKeyShort;
      }
    }
  }
};
